import { z } from "zod";

export const ReactionType = z.enum([
    "like",
    "heart",
    "celebrate",
    "laugh",
    "sad",
    "angry",
    "unlike",
]);

export const Reaction = z.object({
    count: z.number(),
    reacted: z.boolean(),
});

export const ReactionsList = z.record(ReactionType, Reaction);
